import React, { useState } from "react";
import { Consult } from "../../components/Consult";
import { Content } from "antd/es/layout/layout";
import { Button, DatePicker, Select, Table } from "antd";
import { AiOutlineSearch } from "react-icons/ai";
import { useForm } from "antd/es/form/Form";
import locale from "antd/es/date-picker/locale/pt_BR";
import { rangePresets } from "../../constants/constants";
import dayjs from "dayjs";
import api from "../../http/api";
import { columnConfigs } from "./tableDinamicColumn";

const { RangePicker } = DatePicker;

const opcoesRelatorios = [
  { label: "Café", value: "getCafeByData" },
  { label: "Soja", value: "getSojaByData" },
  { label: "Milho", value: "getMilhoByData" },
  { label: "Vaca Gorda (à vista)", value: "getVacaByData" },
  { label: "Bezerro", value: "getBezerroByData" },
  { label: "Bezerra", value: "getBezerraByData" },
  { label: "Garrote", value: "getGarroteByData" },
  { label: "Mercado Atacadista (Gado)", value: "getBoiAtacadoByData" },
  { label: "Boi Magro", value: "getBoiMagroByData" },
  { label: "Boi Gordo (à vista)", value: "getBoiGordoByData" },
  { label: "Boi In Natura", value: "getBoiCarneNaturaByData" },
  { label: "Boi Charque", value: "getBoiCharqueByData" },
  { label: "Boi Cortes", value: "getBoiCortesByData" },
  { label: "Boi Cortes Especiais e Trad.", value: "getBoiCortesTradEspByData" },
  { label: "Boi Couro", value: "getBoiCouroByData" },
  { label: "Boi Diversos", value: "getBoiDiversosByData" },
  { label: "Boi Miúdos", value: "getBoiMiudosByData" },
  { label: "Boi Carne Industrilizada", value: "getBoiCarnInduByData" },
  { label: "Frango", value: "getFrangoByData" },
  { label: "Frango Cortes", value: "getFraCortesByData" },
  { label: "Suíno Cortes", value: "getSuiCortesByData" },
  { label: "Suíno Cortes Especiais e Trad.", value: "getSuiCortesEspByData" },
];

function detectDataType(data) {
  if (!data || data.length === 0) return null;

  const keys = Object.keys(data[0]);

  if (keys.includes("soj_uf")) return "soja";
  if (keys.includes("ata_uf")) return "boiatacado";
  if (keys.includes("diant_boi")) return "boiinnatura";
  if (keys.includes("injetado_diant")) return "charque";
  if (keys.includes("cupim")) return "cortes";
  if (keys.includes("salg")) return "couro";
  if (keys.includes("bilis_conc")) return "diversos";
  if (keys.includes("baco")) return "miudos";
  if (keys.includes("carne_ind")) return "industrializada";
  if (keys.includes("asa")) return "frangocortes";
  if (keys.includes("bar_ccostela_cong")) return "suinocortes";
  if (keys.includes("carc_esp_ata")) return "suinocorstesesp";
  if (keys.includes("alcatra_comp")) return "cortestrad";
  if (keys.includes("caf_categoria")) return "cafe";
  if (keys.includes("mil_uf")) return "milho";
  if (keys.includes("cot_vaca")) return "vaca";
  if (keys.includes("cot_kg")) return "frango";
  if (keys.includes("cot_magro")) return "bezerro";
  if (keys.includes("cot_boi")) return "boigordo";
  if (keys.includes("boi_uf")) return "bezerra";

  return null;
}

export default function Relatorios() {
  const [data, setData] = useState(null);
  const [columns, setColumns] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [form] = useForm();

  async function onFinish(values) {
    const dataini = dayjs(values.dates[0]).format("MM/DD/YYYY");
    const datafim = dayjs(values.dates[1]).format("MM/DD/YYYY");
    console.log(values);

    await api
      .get(`/relatorios/${values.quotation}`, {
        baseURL: process.env.REACT_APP_API_RB,
        params: { data_start: dataini, data_final: datafim },
      })
      .then(({ data }) => {
        const result = data[0];
        setData(result);
        console.log(result);
        const detectedType = detectDataType(result);
        console.log(detectedType);
        if (detectedType) {
          setColumns(columnConfigs[detectedType]);
        } else {
          setColumns([]); // If unknown format, reset columns
        }
      })
      .finally(() => {
        setIsLoading(false);
      })
      .catch((reason) => {
        console.log(reason);
        setIsLoading(false);
      });
  }

  return (
    <Consult.Root panelSizes={["30%", "auto"]}>
      <Consult.Form
        form={form}
        title={"Correções"}
        variant="filled"
        bordered
        onFinish={onFinish}
        extra={
          <Content style={{ display: "flex", gap: 5, justifyContent: "end" }}>
            <Button type="primary" icon={<AiOutlineSearch />} htmlType="submit">
              Buscar
            </Button>
          </Content>
        }
        style={{ width: "100%" }}
      >
        <Consult.Field
          label={"Cotação"}
          name={"quotation"}
          rules={[{ required: true, message: "Escolha uma Cotação!" }]}
          children={
            <Select
              showSearch
              style={{ width: "100%" }}
              optionFilterProp="children"
              placeholder="Selecione uma Cotação"
              filterOption={(input, option) =>
                (option?.label.toLocaleLowerCase() ?? "").includes(
                  input.toLocaleLowerCase()
                )
              }
              options={opcoesRelatorios}
            />
          }
        />
        <Consult.Field
          label={"Data Inicial e Final"}
          name={"dates"}
          rules={[
            { required: true, message: "Selecione uma data inicial e final!" },
          ]}
          hasFeedback
          children={
            <RangePicker
              style={{ width: "100%" }}
              presets={rangePresets}
              locale={locale}
            />
          }
        />
      </Consult.Form>
      <Content style={{ width: "100%", height: "100%", overflowY: "scroll" }}>
        <Table
          loading={isLoading}
          columns={columns}
          dataSource={data}
          pagination={false}
        />
      </Content>
    </Consult.Root>
  );
}
